import React, { Component } from 'react';
import { formatDate } from '../../Util';

class NotifItem extends Component {

  	render() {
	    return (
			<div className="notificationsItem">
				<div className="creator"><span className="name">{this.props.project.creator_name}</span> invited you to join this project</div>
				<div className="title">{this.props.project.title}</div>
				<div className="end_at">Ending {formatDate(this.props.project.project_end_at)}</div>
				<div className="description">{this.props.project.description}</div>
			</div>
	    );
  	}
}

export default NotifItem;



// WEBPACK FOOTER //
// ./src/components/Modal/NotifItem.js